export const isVisitCancelable = (visitStatus: string) => {
  return (
    {
      scheduled: true,
      en_route: true,
      arrived: true,
      in_progress: false,
      complete: false,
      canceled: false,
    }[visitStatus] ?? false
  );
};
